import React from 'react';
import { Palette } from 'lucide-react';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-amber-50 to-orange-100 flex items-center justify-center">
      <div className="text-center">
        <div className="mb-8">
          <Palette className="w-16 h-16 text-amber-600 mx-auto animate-pulse" />
        </div>
        
        <h1 className="text-4xl font-bold text-amber-800 mb-4">
          David's Art Gallery
        </h1>
        
        <p className="text-lg text-amber-700 mb-8">
          Loading your immersive 3D art experience...
        </p>
        
        <div className="flex items-center justify-center space-x-2">
          <div className="w-3 h-3 bg-amber-600 rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-amber-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-3 h-3 bg-amber-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;